<template>
    <div class="right-aside">
        <div class="right-aside-content">
            <div class="right-aside-zitems">
                <DataStatistics
                    :dataList="dataList"
                    @bindData="bindData"
                    :currentIndex="listType"
                ></DataStatistics>
            </div>
            <div class="aside-list">
                <template v-if="listType === 0">
                    <template v-if="eventList && eventList.length > 0">
                        <YScroll style="height: 100%">
                            <el-popover
                                v-for="(item, index) in eventList"
                                :key="item.id + index"
                                popper-class="c-el-popover-blue main-task-tree-el-popover"
                                effect="dark"
                                placement="right-start"
                                trigger="hover"
                            >
                                <div
                                    slot="reference"
                                    class="aside-list-item display mar-bot-7"
                                    :class="activityId === item.id ? 'active' : 'empty'"
                                    @click="bindEvent(item)"
                                >
                                    <div class="item-img">
                                        <el-image class="img" :src="item.thumbnailUrl" fit="cover"></el-image>
                                    </div>
                                    <div class="item-main">
                                        <div class="item-title display mar-bot-7">
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                :content="item.name"
                                                placement="top"
                                                popper-class="txt-tooltip "
                                            >
                                                <div class="item-name">
                                                    {{ item.name }}
                                                </div>
                                            </el-tooltip>
                                            <div
                                                class="item-status"
                                                :class="{
                                                    'is-unstart': item.status == 1,
                                                    'is-starting': item.status == 2,
                                                    'is-started': item.status == 3,
                                                    'is-resulted': item.status == 4,
                                                    'is-end': item.status == 5,
                                                    'is-stop': item.status == 6,
                                                }"
                                            >
                                                {{ item.statusLabel }}
                                            </div>
                                        </div>
                                        <div class="item-data display mar-bot-7">
                                            <div class="item-txt">
                                                {{ $t('chengguan.dailypatrol.discoveryTime') }}
                                            </div>
                                            <div class="item-val">{{ item.eventTime }}</div>
                                        </div>
                                        <div class="item-location display mar-bot-7">
                                            <div class="item-txt">
                                                {{ $t('chengguan.dailypatrol.location') }}
                                            </div>
                                            <div class="item-val">{{ item.location }}</div>
                                        </div>
                                    </div>
                                </div>
                                <template>
                                    <EventPop
                                        class="event-popup-content"
                                        :itemObj="item"
                                        :clickable="false"
                                        :border="false"
                                        :translate="(key) => $t(key)"
                                    >
                                    </EventPop>
                                </template>
                            </el-popover>
                        </YScroll>
                    </template>
                    <template v-else>
                        <div class="aside-list-empty">{{ $t('chengguan.dailypatrol.noDataAvailable') }}</div>
                    </template>
                </template>
                <template v-else>
                    <template v-if="taskList && taskList.length > 0">
                        <YScroll style="height: 100%">
                            <div
                                v-for="(taskItem, index) in taskList"
                                :key="index"
                                class="task-item"
                                :class="activityId === taskItem.id ? 'active' : 'empty'"
                                @click="bindTask(taskItem)"
                            >
                                <span>{{ taskItem.name }}</span>
                                <span>{{ taskItem.executionEndTime }}</span>
                            </div>
                        </YScroll>
                    </template>
                    <template v-else>
                        <div class="aside-list-empty">{{ $t('chengguan.dailypatrol.noDataAvailable') }}</div>
                    </template>
                </template>
            </div>
        </div>
        <div class="right-aside-bottom display" v-if="eventList.length > 1">
            <div class="bottom-total display">
                {{ $t('chengguan.dailypatrol.total') }}
                <div class="total-num">{{ eventList.length }}</div>
                {{ $t('chengguan.dailypatrol.strip') }}
            </div>
            <div class="bottom-content">
                <el-pagination
                    class="pagination-mian"
                    small
                    background
                    align="center"
                    layout="prev, pager, next"
                    :pager-count="5"
                    :total="searchForm.totalResult"
                    :page-size="searchForm.pageSize"
                    :current-page="searchForm.pageNum"
                    @current-change="currentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { YScroll } from '@CommonComponent';
import DateUtil from '@/utils/DateUtil.js';
import DatepickerMixin from '@/mixins/datepicker.js';

import DataStatistics from '../../components/DataStatistics.vue';
import Pagination from '@/page/taskPage/common/Pagination.vue';
import EventPop from '@/page/mainPage/mapComponents/EventPop.vue';
import { getSuspiciousEventDetail, getSuspiciousEvents } from '../api/grid.js';

export default {
    mixins: [DatepickerMixin],
    components: {
        DataStatistics,
        YScroll,
        Pagination,
        EventPop,
    },
    props: {
        queryDate: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            dataList: [],
            listType: 0,
            activityId: '',
            routeObj: {},
            searchForm: {
                pageNum: 1,
                pageSize: 10,
                totalResult: 0,
            },
            eventList: [],
            taskList: [],
        };
    },
    watch: {
        queryDate: {
            handler(newVal) {
                let id = this.routeObj.gridId;
                if (id) {
                    this.handleGridDatePickerChange();
                } else {
                    this.getTopData({ suspiciousEventCount: 0, flightRecordCount: 0 });
                }
            },
            immediate: true,
            deep: true,
        },
        eventList: {
            handler(newVal) {
            },
            immediate: true,
            deep: true,
        },
        '$route.query': {
            handler(newVal) {
                // 获取当前 URL 的查询字符串
                this.routeObj = newVal || { taskId: '', gridId: '', gridGroupId: '' };

                if (this.routeObj.taskId) {
                    this.listType = 1;
                    this.activityId = this.routeObj.taskId;
                } else if (this.routeObj.gridId) {
                    this.listType = 0;
                    let id = this.routeObj.gridId;
                    this.getSuspiciousEvents(id);
                }
                this.handleGridDatePickerChange();
            },
            immediate: true,
            deep: true,
        },

    },
    computed: {
        pickerOptions() {
            return {
                ...this.mixinPickerOptions,
                onPick: ({ maxDate, minDate }) => {
                    // 当开始日期选中时，设置限制
                    if (minDate && !maxDate) {
                        const oneYearLater = new Date(minDate);
                        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
                        this.maxSelectableDate = oneYearLater;
                    } else {
                        this.maxSelectableDate = null;
                    }
                },
                disabledDate: (time) => {
                    const [start, end] = this.dateRange || [];
                    if (start && !end) {
                        const startTime = new Date(start).getTime();
                        const maxTime = new Date(start);
                        maxTime.setFullYear(maxTime.getFullYear() + 1);
                        return time.getTime() > maxTime.getTime();
                    }
                    return false;
                },
            };
        },
    },
    methods: {
        /**
         * 处理网格巡查日期选择器变化时的事件，去查询任务
         */
        handleGridDatePickerChange() {
            let id = this.routeObj.gridId;
            if (this.listType === 0) {
                this.getSuspiciousEvents(id);
            } else {
                this.getSuspiciousEventDetail(id);
            }
        },

        // 获取网格单元的异常事件列表
        async getSuspiciousEvents(id) {
            let params = this.getParams(id);
            let ref = await getSuspiciousEvents(params);
            if (ref.code === 200) {
                let tableDataInfo = ref.data.tableDataInfo || {};
                this.eventList = tableDataInfo.rows || [];
                this.searchForm.totalResult = tableDataInfo.total || 0;
                this.getTopData(ref.data);
                this.$emit('getEventList', this.eventList);
            } else {
                this.$message.error(ref.msg);
            }
        },
        // 获取网格单元的巡查任务列表

        async getSuspiciousEventDetail(id) {
            let params = this.getParams(id);
            let ref = await getSuspiciousEventDetail(params);
            if (ref.code === 200) {
                let tableDataInfo = ref.data.tableDataInfo || {};
                this.taskList = tableDataInfo.rows || [];
                this.searchForm.totalResult = tableDataInfo.total || 0;
                this.getTopData(ref.data);
            } else {
                this.$message.error(ref.msg);
            }
        },
        // 接口参数封装

        getParams(id) {
            let params = {
                id,
                pageNum: this.searchForm.pageNum,
                pageSize: this.searchForm.pageSize,
            };
            if (this.queryDate) {
                params = {
                    ...params,
                    beginTime: this.queryDate[0],
                    endTime: this.queryDate[1],
                };
            }
            return params;
        },
        // 获取顶部数据统计信息
        getTopData(data) {
            let list = [
                {
                    id: 0,
                    url: 'icon-suspected',
                    name: this.$t('chengguan.dailypatrol.suspectedEventDiscovered'),
                    unit: this.$t('chengguan.dailypatrol.piece'),
                    value: data.suspiciousEventCount || 0,
                },
                {
                    id: 1,
                    url: 'icon-patrol',
                    name: this.$t('chengguan.dailypatrol.inspectionFrequency'),
                    unit: this.$t('chengguan.dailypatrol.order'),
                    value: data.flightRecordCount || 0,
                },
            ];
            this.dataList = list;
        },
        // 点击事件详情
        bindEvent(item) {
            this.activityId = item.id;

            this.$emit('bindSearch', item.id);
        },

        // 点击任务详情
        bindTask(item) {
            this.activityId = item.id;
            this.$emit('bindTaskImg', item.id);
        },
        // 发现事件和巡查任务切换事件
        bindData(val) {
            this.listType = val.id;
            if (val.id === 0) {
                this.getSuspiciousEvents(this.routeObj.gridId);
            } else {
                this.getSuspiciousEventDetail(this.routeObj.gridId);
            }
        },
        getStatusText(el) {
            switch (el) {
                case '1':
                    return this.$t('taskPage.taskTable2.pendingExecution');
                case '2':
                    return this.$t('taskPage.taskTable2.executing');
                case '3':
                    return this.$t('taskPage.taskTable2.executed');
                case '4':
                    return this.$t('taskPage.taskTable2.resultProcessing');
                case '5':
                    return this.$t('taskPage.taskTable2.completed');
                case '6':
                    return this.$t('taskPage.taskTable2.terminated');
                default:
                    return '';
            }
        },
        fetchData(val) {
            this.searchForm.pageNum = val.page;
            this.searchForm.pageSize = val.rows;
            this.searchRiver();
        },
        currentChange(e) {
            this.searchForm.pageNum = e;
            this.getSuspiciousEvents(this.routeObj.gridId);
            // this.$props.searchRoute(this.searchForm);
        },
    },
    created() {},
    mounted() {
        const queryString = this.$route.query;
        this.routeObj = queryString;
        if (this.routeObj.taskId) {
            this.listType = 1;
            this.activityId = this.routeObj.taskId;
        } else if (this.routeObj.gridId) {
            this.listType = 0;
            let id = this.routeObj.gridId;
            this.getSuspiciousEvents(id);
        }
    },
};
</script>
<style lang="scss" scoped>
.right-aside {
    padding: 10px;
    .right-aside-header {
        padding: 8px 0;
        .aside-search {
            .aside-search-label {
                width: 90px;
                line-height: 30px;
            }
            .aside-daterange {
                // background: hsl(238deg, 91%, 13%);
                // border: 1px solid #1947a3;
                .el-range-input {
                    // background: hsl(238deg, 91%, 13%);
                }
            }
        }
    }
    .right-aside-content {
        padding: 8px 0;

        .aside-list {
            height: 65vh;
            margin-top: 16px;
            position: relative;
            .aside-list-item {
                // height: 90px;

                border-radius: 2px 2px 2px 2px;
                border: 1px solid #1a47a4;
                margin-bottom: 12px;
                padding: 5px 0 5px 10px;

                &:hover {
                    background: rgba(30, 118, 237, 0.7);
                }

                .item-num {
                    width: 10px;
                    margin-right: 5px;
                    text-align: center;
                }
                .item-img {
                    margin: 5px 5px 5px 0;
                    width: 80px;
                    height: 60px;

                    .img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .item-main {
                    width: 75%;
                    .item-name {
                        width: 138px;
                        margin-right: 10px;
                        line-height: 22px;
                        font-size: 14px;
                        white-space: nowrap; /* 不换行 */
                        overflow: hidden; /* 隐藏超出的内容 */
                        text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
                    }
                    .item-status {
                        padding: 4px;
                        font-size: 12px;
                        max-width: 80px;
                    }
                    .item-txt {
                        max-width: 80px;
                        margin-right: 8px;
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.6);
                    }
                    .item-val {
                        color: rgba(255, 255, 255, 0.6);
                        font-size: 12px;
                        width: 120px;
                        white-space: nowrap; /* 不换行 */
                        overflow: hidden; /* 隐藏超出的内容 */
                        text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
                    }
                }
            }
            .task-item {
                line-height: 20px;
                background: #112d7b;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #1a47a4;
                margin-bottom: 12px;
                padding: 10px;
                &:hover {
                    background: rgba(30, 118, 237, 0.7);
                }
            }
        }
        .aside-list-empty {
            width: 100%;
            height: 650px;
            line-height: 650px;
            text-align: center;
        }
    }
    .right-aside-bottom {
        position: absolute;
        bottom: 15px;
        left: 15px;
        right: 10px;
        height: 30px;
        background: linear-gradient(180deg, rgba(7, 17, 80, 0) 0%, #071150 100%);
        .bottom-total {
            text-align: center;
            line-height: 25px;
            .total-num {
                width: 20px;
            }
        }
        .pagination-mian {
            color: #fff;
            ::v-deep .el-pagination__jump {
                color: #fff;
            }
        }
    }
}
.display {
    display: flex;
}
.mar-bot-7 {
    margin-bottom: 7px;
}
.main-task-tree-el-popover {
    background: #071150 !important;
}
.active {
    background: rgba(30, 118, 237, 0.7) !important;
}
.empty {
    background: #112d7b !important;
}
</style>

<style lang="scss">
.bottom-content {
    .el-input__inner {
        background-color: #112d7b !important;
        border: 1px solid #1a47a4 !important;
        box-sizing: border-box;
        color: #ffffff;
        display: inline-block;
        font-size: inherit;
        height: 30px;
        line-height: 30px;
        outline: 0;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        margin: 0 5px;
        background-color: #112d7b;
        border-radius: 2px;
        color: #fff;
    }
    .btn-next {
        /*对下一页的按钮样式进行修改*/
        background-color: #112d7b;
        color: #fff;
    }
    .btn-prev {
        /*对上一页的按钮样式进行修改*/
        background-color: #112d7b;
        color: #fff;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: rgba(73, 240, 253, 0.2) !important;
    }
}
</style>
